<template>
  <div class="login-container min-container">
    <i class="icon-logo"></i>
    <div class="common-func-login login-wrap">
      <div class="pg"></div>
      <div class="login-main">
        <div>
          <p class="common-tab">考试阅卷系统</p>
          <div class="login-item">
            <div class="wrap">
              <phone-login ref="loginDom"></phone-login>
              <div class="login-btn-wrap">
                <span class="loading" v-if="loading">
                  <loading
                    :box-size="4"
                    :round-size="1"
                    :color="'#fff'"></loading>
                </span>
                <countdown-btn
                  ref="loginBtn"
                  el="button"
                  type="submit"
                  class="login-btn"
                  placeholder="登录"
                  lockTmp="%s秒"
                  clickTips="请稍后"
                  @click="login"></countdown-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneLogin from '@/views/Login/PhoneLogin'
import CountdownBtn from '@/components/CountdownBtn'
import { mapMutations } from 'vuex'
import { get } from '@/utils/ajax'
import Loading from '@/components/Loading'
import { loginEvent } from '@/utils/sensor'

export default {
  components: {
    PhoneLogin,
    CountdownBtn,
    Loading
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    ...mapMutations({
      setUser: 'SET_USER',
      setExaminee: 'SET_EXAMINEE_INFO'
    }),
    async login(lock, reset) {
      reset()
      try {
        await this.$refs.loginDom.validationTouch()
      } catch (error) {
        return
      }
      this.loading = true
      // const isMonitor = await this.getIsMonitor()
      const isMonitor = true
      if (isMonitor) {
        try {
          const auth = await this.changeLoginSDK()
          this.$store.commit('HAS_TOKEN', true)
          const user = {}
          user.weakPassword = auth.is_weak_password
          this.setUser(user)
          const userInfo = await this.$auth('get_profile')
          this.$store.commit('SET_USER', userInfo)
          loginEvent(userInfo)
          localStorage.examId = ''
          this.$message.success('登录成功')
          this.$router.push({ name: 'judgeSelect' })
          this.$refs.loginDom.form.code = ''
        } catch (e) {
          if (++this.errorNum >= 5) {
            this.errorNum = 'password'
            localStorage.setItem('loginCountdownBtn', +new Date() + 60 * 1000)
            this.$message.error('操作频繁，请1分钟后再试！')
            lock()
          }
        }
      } else {
        this.$message.error('账号或者密码错误，请重新登录～')
      }
      this.loading = false
    },
    async changeLoginSDK () {
      let auth = {}
      const { phone, code } = this.$refs.loginDom.form
      this.account = phone
      const res = await this.$auth('login_phone', ...[phone, code])
      auth = res.auth
      // 防止重复登录串号
      localStorage.setItem('currentAccount', '')
      localStorage.currentPhone = phone
      return auth
    },
    // 判断登录账号是否为考点端账号
    async getIsMonitor() {
      const username = this.$refs.loginDom.form.account
      const { name, result } = await get(`/home/proctor/pro/exist`, { username: username })
      this.$store.commit('SETSTATE', [{ key: 'isMonitor', value: result }, { key: 'monitorName', value: name }])
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.login-container {
  .icon-logo {
    display: inline-block;
    width: 275px;
    height: 40px;
    // background: url("~@/assets/images/logo.png") center / cover no-repeat;
    // background: #fff;
    margin: 20px 0 80px 80px;
  }
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  background: #FAFAFA;
  .login-wrap {
    position: relative;
    display: flex;
    width: 1160px;
    height: 600px;
    border-radius: 8px;
    box-shadow: 0 10px 36px 0 rgba(48,111,255,0.15);
    margin: 0 auto 100px;
    overflow: hidden;
    &.monitor-login {
      box-shadow: 0 10px 36px 0 rgba(0, 0, 0, 0.06);
    }
  }
  .brand {
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 20px;
    left: 0;
    font-size: 12px;
    font-weight: 300;
    color: #999;
  }
  .pg {
    width: 520px;
    height: 600px;
    background: url('~@/assets/images/login/login-bg-judge.png') no-repeat center / cover;
    box-shadow: 4px 4px 12px 0 rgba(48,111,255,0.4);
  }
  .monitor-bg {
    width: 520px;
    height: 600px;
    // background: url('~@/assets/images/monitor/login-bg.png') no-repeat center / cover;
    background: url('~@/assets/images/login/login-bg-judge.png') no-repeat center / cover;
    box-shadow: 0 10px 36px 0 rgba(0, 0, 0, 0.06);
  }
}
.tab-func {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  font-size: 14px;
  font-weight: 300;
  color: $themeColor;
}
.login-main {
  position: relative;
  background: #fff;
  flex: 1;
  border-radius: 0 8px 8px 0;
}
.login-item {
  width: 416px;
  margin: auto;
}
.common-tab {
  text-align: center;
  margin: 127px auto 20px;
  color: $titleColor;
  font-size: 24px;
  font-weight: 500;
}
.login-btn {
  display: block;
  margin-top: 60px;
  @include theme-fill-btn(416px, 44px, 16px, 2px);
}
.login-btn-wrap {
  position: relative;
  .loading {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/.spinner {
      transform: translateX(-44px);
    }
  }
}
</style>

<style lang="scss" src="@/assets/styles/login.scss"></style>
